import { useState } from 'react';
import ArticleLayout from '@/components/ArticleLayout';

export default function ContactPage() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const hp = formData.get('contact_alt') as string;
    if (hp && hp.trim()) {
      setStatus('success');
      return;
    }
    setStatus('success');
    form.reset();
  };

  return (
    <ArticleLayout
      title="Contact Us"
      description="Get in touch with the CSSBuy Spreadsheet resource team."
      breadcrumbs={[
        { label: 'Home', to: '/' },
        { label: 'Contact', to: '/contact' },
      ]}
    >
      <p className="mb-6">
        Have questions about CSSBuy Spreadsheet or suggestions for our guides? We would love to hear from you. Fill out the form below and we will get back to you as soon as possible.
      </p>

      {status === 'success' && (
        <div className="mb-6 p-4 bg-primary-50 border border-primary-200 rounded-xl text-sm text-primary-700">
          Thank you for your message. We will review it shortly.
        </div>
      )}
      {status === 'error' && errorMsg && (
        <div className="mb-6 p-4 bg-accent-50 border border-accent-200 rounded-xl text-sm text-accent-700">
          {errorMsg}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4 max-w-lg" data-readdy-form="contact">
        <div className="hp-field">
          <input type="text" name="contact_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground-700 mb-1">Name</label>
          <input
            type="text"
            name="name"
            required
            className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-primary-400"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground-700 mb-1">Email</label>
          <input
            type="email"
            name="email"
            required
            className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-primary-400"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground-700 mb-1">Message</label>
          <textarea
            name="message"
            required
            maxLength={500}
            rows={4}
            className="w-full px-4 py-2.5 bg-background-100 border border-background-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 resize-y"
          />
          <p className="text-xs text-foreground-500 mt-1">Maximum 500 characters</p>
        </div>
        <button
          type="submit"
          className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-xl text-sm font-medium hover:bg-primary-600 transition-colors"
        >
          Send Message
        </button>
      </form>
    </ArticleLayout>
  );
}